import { Box, Text } from '@mantine/core';
import { formatDistanceToNow, parseISO } from 'date-fns';
import { useAppSelector } from '../../../app/hooks';
import { selectCurrentClip } from '../clipQueueSlice';
import Platform from '../../../common/components/BrandPlatforms';

interface PlayerTitleProps {
  className?: string;
}

const _nbsp = <>&nbsp;</>;

function PlayerTitle({ className }: PlayerTitleProps) {
  const currentClip = useAppSelector(selectCurrentClip);

  return (
    <Box className={className} sx={{ strong: { fontWeight: 600 } }}>
      <Text size="xl" weight={700} lineClamp={1}>
        {currentClip?.title ?? _nbsp}
      </Text>
      <Text sx={{ display: 'flex', alignItems: 'center', gap: '.25rem' }} color="dimmed" size="sm" lineClamp={1}>
        <Platform platform={currentClip?.Platform} />
        <strong>{currentClip?.author ?? _nbsp}</strong>
        {currentClip?.category && (
          <>
            {' ('}
            <strong>{currentClip?.category}</strong>
            {')'}
          </>
        )}
        {currentClip?.submitters[0] && (
          <>
            , enviado por <strong>{currentClip?.submitters[0]}</strong>
            {currentClip?.submitters.length > 1 && <> e mais {currentClip.submitters.length - 1}</>}
          </>
        )}
        {currentClip?.createdAt && <>, criado há {formatDistanceToNow(parseISO(currentClip?.createdAt))}</>}
      </Text>
    </Box>
  );
}

export default PlayerTitle;
